
//const BASE_URL = 'http://127.0.0.1:5000/presigned_url';
const BASE_URL = 'https://zoabdrjitpu23ilf6q3efgjiue0xpuhq.lambda-url.us-east-1.on.aws/presigned_url?';
const bucketName = 'smartapps-gbm-dev';

async function getPresignedURL(fileName, fileType){
    const url = BASE_URL + new URLSearchParams({fileName : fileName, fileType: fileType})
    try{
        const s3PresignedURL = await fetch(url, {
                                     method: 'get',
        }).then(res => res.text())
        return s3PresignedURL
    }
    catch(error){
        console.error(error)
    }
}

export {getPresignedURL}